/**
 * Sagas that are run on *every* page
 */
import cartSagas from './cartSagas';
import mislSagas from './mislSagas';
import userSagas from './userSagas';
import utagSagas from './utagSagas';
import ugcSagas from './ugcSagas';
import favoritesSagas from './favoritesSagas';
import engageSagas from './engageSagas';
import { getSaytSagas } from './saytSagas';

const sagas = [
    ...cartSagas,
    ...mislSagas,
    ...getSaytSagas(),
    ...userSagas,
    ...utagSagas,
    ...ugcSagas,
    ...favoritesSagas,
    ...engageSagas
];

export default sagas;
